import React from "react";
import { Form } from "react-bootstrap";
import { Typeahead } from 'react-bootstrap-typeahead';
import useUniqueId from "./useUniqueId";

export type TypedSelectProps = {
    value: any;
    options: any[];
    textGetter?: ((value: any) => string) | string
    valueGetter(value: any): string | number;
    onValueSelected(value: any): void;
    showNullRow?: boolean;
    nullRowText?: string;
    autoComplete?: boolean;
    placeholder?: string;

    enforceValidOption?: boolean;
    includeInvalidOption?: boolean;
    disabled?: boolean;
    required?: boolean;
    className?: string;
    style?: any;
};


const TypedSelect: React.FC<TypedSelectProps> = (props: TypedSelectProps) => {

    const componentId = useUniqueId();

    let options = props.options;
    if ((props.enforceValidOption || props.includeInvalidOption) && !options.some(m => getValue(m) === getValue(props.value))) {
        
        if (props.enforceValidOption && !props.disabled && options.length > 0) {
            //Force a selection of the first option
            const validValue = options[0];
            props.onValueSelected(validValue);
        }

        if (props.includeInvalidOption) {
            //Include current value as an option
            options = [props.value, ...props.options];
        }
    }


    function getValue(item: any) {
        return item == null ? "" : props.valueGetter(item);
    }

    function getText(item: any) {
        if (item == null)
            return props.nullRowText;
        return typeof (props.textGetter) === 'function'
            ? props.textGetter(item)
            : item[props.textGetter];
    }

    function onValueChanged(value: string | number) {
        const newValue = options.find(m => getValue(m).toString() === value);

        props.onValueSelected(newValue);
    }

    function onAutoCompleteValueChanged(selectedItem: any[]) {
        props.onValueSelected(selectedItem[0]);
    }

    return (
        props.autoComplete ? <Typeahead
            id={componentId}
            disabled={props.disabled}
            inputProps={{ required: props.required }}
            placeholder={props.placeholder}
            labelKey={props.textGetter}
            options={options}
            selected={props.value ? [props.value] : []}
            onChange={(ev) => onAutoCompleteValueChanged(ev)}
        />
            : <Form.Control as="select"
                value={getValue(props.value) ?? ""}
                style={props.style}
                required={props.required}
                onChange={(ev: React.ChangeEvent<HTMLSelectElement>) => onValueChanged(ev.target.value)}
                className={props.className}
                placeholder={props.placeholder}
                disabled={props.disabled}>
                {props.showNullRow && <option value="">{props.nullRowText}</option>}
                {options.map(o => (
                    <option
                        key={getValue(o)}
                        value={getValue(o)}>
                        {getText(o)}
                    </option>
                ))}
            </Form.Control>
    );
}

export default React.memo(TypedSelect);